import React from 'react';
import { UserInviteCreate } from '../../../../services/openapi/models/UserInviteCreate';
import { SharedFolder } from '../../../../services/openapi/models/SharedFolder';
interface IUserCreationContext{
    code: string;
    setCode: (code: string) => void;

    email: string;
    setEmail: (email: string) => void;
    
    name: string;
    setName: (name: string) => void;

    kundennummer: string;
    setKundennummer: (kundennummer: string) => void;

    isOwner: boolean;
    setIsOwner: (isOwner: boolean) => void;
    
    accessibleFolders: SharedFolder[];
    setAccessibleFolders: (accessibleFolders: SharedFolder[]) => void;

    userGroups: string[];
    setUserGroups: (userGroups: string[]) => void;

    Ansprechpartner: string;
    setAnsprachpartner: (Ansprechpartner: string) => void;

    Mail_Ansprechpartner: string;
    setMail_Ansprachpartner: (Ansprechpartner: string) => void;

    resetUserPreConf: () => void;
    buildEnvelope: () => UserInviteCreate;
}


const defaultContext:IUserCreationContext = {
    code: "",
    setCode: () => {
        // Initial value. Replaced by context provider.
        
    },
    email: "",
    setEmail: () => {
        // Initial value. Replaced by context provider.
        
    },
    name: "",
    setName: () => {
        // Initial value. Replaced by context provider.
        
    },
    kundennummer: "",
    setKundennummer: () => {
        // Initial value. Replaced by context provider.
        
    },
    isOwner: false,
    setIsOwner: () => {
        // Initial value. Replaced by context provider.
        
    },
    accessibleFolders: [],
    setAccessibleFolders: () => {
        // Initial value. Replaced by context provider.
        
    },
    userGroups: [],
    setUserGroups: () => {
        // Initial value. Replaced by context provider.
        
    },
    Ansprechpartner: "",
    setAnsprachpartner: () => {},
    Mail_Ansprechpartner: "",
    setMail_Ansprachpartner: () => {},
    
    resetUserPreConf: () => {
        // Initial value. Replaced by context provider.
    },
    buildEnvelope: () => {
        return {
            email: "",
            name: "",
            kundenummer: "",
            Ansprechpartner:"",
            Mail_Anprechpartner:"",
            isOwner: false,
            usergroups: [],
            folders: []
        }
        // Initial value. Replaced by context provider.
    }
};

const UserCreationContext = React.createContext(defaultContext);

export default UserCreationContext;
